/* Posana funnel behaviour. Vanilla JS, no dependencies. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var G = {};
  try { G = JSON.parse(($('#pf-global-data') || {}).textContent || '{}'); } catch (e) {}
  var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
  var fmtr = new Intl.NumberFormat('en-US', { style: 'currency', currency: cur });
  var money = function (cents) { return fmtr.format(Math.round(cents) / 100); };
  var store = {
    get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  };

  /* ---------- Scroll to buy box ---------- */
  function goTo(hash) {
    var el = $(hash) || (hash === '#pf-buy' ? $('#pf-flavors') : null); if (!el) return;
    var sticky = $('[data-pf-sticky]');
    var off = (sticky && window.matchMedia('(min-width: 990px)').matches) ? 80 : 12;
    window.scrollTo({ top: el.getBoundingClientRect().top + window.pageYOffset - off, behavior: 'smooth' });
    if (hash === '#pf-buy') { var f = $('[data-pf-flavs] [aria-checked="true"]'); if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 600); }
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-pf-scroll]');
    if (!a) return;
    var h = a.getAttribute('href');
    if (h && h.charAt(0) === '#') { e.preventDefault(); goTo(h); }
  });

  /* ---------- Countdown (only with a real end date) ---------- */
  $$('[data-pf-countdown]').forEach(function (el) {
    var end = Date.parse(el.getAttribute('data-pf-countdown'));
    if (!end) return;
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    (function tick() {
      var d = end - Date.now();
      if (d <= 0) { el.hidden = true; return; }
      var h = Math.floor(d / 36e5), m = Math.floor(d % 36e5 / 6e4), s = Math.floor(d % 6e4 / 1e3);
      el.textContent = (h >= 48 ? Math.floor(h / 24) + 'd ' + pad(h % 24) : pad(h)) + ':' + pad(m) + ':' + pad(s);
      el.hidden = false;
      setTimeout(tick, 1000);
    })();
  });

  /* ---------- Accordions: one open at a time ---------- */
  $$('[data-pf-acc]').forEach(function (acc) {
    acc.addEventListener('toggle', function (e) {
      if (!e.target.open) return;
      $$('details[open]', acc).forEach(function (d) { if (d !== e.target) d.open = false; });
    }, true);
  });

  /* ---------- Review tabs ---------- */
  $$('[data-pf-tabs]').forEach(function (tabs) {
    var revs = $$('.pf-rev', tabs.parentNode);
    tabs.addEventListener('click', function (e) {
      var b = e.target.closest('[data-topic]'); if (!b) return;
      $$('[role=tab]', tabs).forEach(function (t) { t.setAttribute('aria-selected', t === b ? 'true' : 'false'); });
      var t = b.getAttribute('data-topic');
      revs.forEach(function (r) { r.hidden = !(t === 'all' || r.getAttribute('data-topic') === t); });
    });
  });

  /* ---------- UGC strip ---------- */
  $$('[data-pf-ugc]').forEach(function (strip) {
    var wrap = strip.parentNode;
    var step = function () { var c = $('.pf-ugc__card', strip); return c ? c.getBoundingClientRect().width + 12 : 300; };
    var p = $('[data-pf-ugc-prev]', wrap), n = $('[data-pf-ugc-next]', wrap);
    if (p) p.addEventListener('click', function () { strip.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (n) n.addEventListener('click', function () { strip.scrollBy({ left: step(), behavior: 'smooth' }); });
    strip.addEventListener('click', function (e) {
      var b = e.target.closest('[data-pf-video]'); if (!b) return;
      var v = document.createElement('video');
      v.src = b.getAttribute('data-pf-video'); v.controls = true; v.autoplay = true; v.playsInline = true;
      v.setAttribute('playsinline', ''); v.style.position = 'absolute'; v.style.inset = '0';
      b.parentNode.appendChild(v); b.remove(); v.play().catch(function () {});
    });
  });

  /* ---------- Sticky bar: after the hero, hidden over the buy box ---------- */
  var sticky = $('[data-pf-sticky]');
  if (sticky && 'IntersectionObserver' in window) {
    var heroGone = false, buyIn = false;
    var hero = $('#pf-hero'), buy = $('#pf-buy');
    var upd = function () {
      var on = heroGone && !buyIn && !document.body.classList.contains('pf-lock');
      sticky.classList.toggle('is-on', on);
      sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
      $$('a,button', sticky).forEach(function (x) { x.tabIndex = on ? 0 : -1; });
    };
    if (hero) new IntersectionObserver(function (es) { heroGone = !es[0].isIntersecting && es[0].boundingClientRect.top < 0; upd(); }).observe(hero);
    else heroGone = true;
    if (buy) new IntersectionObserver(function (es) { buyIn = es[0].isIntersecting; upd(); }, { rootMargin: '0px 0px -30% 0px' }).observe(buy);
  }

  /* ---------- Email side tab -> real Klaviyo form, one popup only ---------- */
  var side = $('[data-pf-side]');
  if (side) {
    var key = 'pf_side_closed', days = +side.getAttribute('data-days') || 7;
    var closed = +store.get(key) || 0;
    if (Date.now() - closed > days * 864e5) side.hidden = false;
    $('[data-pf-side-x]', side).addEventListener('click', function () { side.hidden = true; store.set(key, String(Date.now())); });
    $('[data-pf-side-open]', side).addEventListener('click', function () {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', side.getAttribute('data-form')]);
    });
  }

  /* ---------- Cart drawer ---------- */
  var drawer = $('[data-pf-drawer]');
  var lastFocus = null;
  function openDrawer() {
    if (!drawer) { window.location.href = '/cart'; return; }
    lastFocus = document.activeElement;
    drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('pf-lock');
    if (sticky) sticky.classList.remove('is-on');
    var x = $('.pf-drawer__head .pf-x', drawer); if (x) x.focus();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('pf-lock');
    if (lastFocus) lastFocus.focus({ preventScroll: true });
  }
  if (drawer) {
    $$('[data-pf-drawer-close]', drawer).forEach(function (b) { b.addEventListener('click', closeDrawer); });
    document.addEventListener('keydown', function (e) {
      if (!drawer.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeDrawer();
      if (e.key === 'Tab') {
        var f = $$('a[href],button:not([disabled])', $('.pf-drawer__panel', drawer)).filter(function (x) { return x.offsetParent; });
        if (!f.length) return;
        if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      }
    });
  }
  var pct = (+G.discountPercent || 0) / 100;
  function applyCode() {
    if (!G.discountCode) return Promise.resolve();
    return fetch('/discount/' + encodeURIComponent(G.discountCode) + '?redirect=%2Fcart.js', { credentials: 'same-origin' }).catch(function () {});
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function renderCart(cart) {
    if (!drawer) return;
    var items = $('[data-pf-items]', drawer);
    $('[data-pf-count]', drawer).textContent = cart.item_count;
    // cart.total_price already includes the code once /discount/<code> has been applied
    var codeOn = (cart.cart_level_discount_applications || []).length > 0 || cart.items.some(function (it) { return (it.line_level_discount_allocations || []).length; });
    var now = cart.total_price, was = cart.original_total_price;
    var thr = +G.freeShipping || 0;
    var shipText = $('[data-pf-ship-text]', drawer), bar = $('[data-pf-ship-bar]', drawer);
    if (thr) {
      var left = thr - now;
      shipText.innerHTML = cart.item_count === 0 ? 'Free shipping on orders over <b>' + money(thr) + '</b>'
        : left > 0 ? 'You\u2019re <b>' + money(left) + '</b> away from <b>free shipping</b>' : '<b>You\u2019ve unlocked free shipping!</b>';
      bar.style.width = Math.min(100, Math.round(now / thr * 100)) + '%';
    } else { $('[data-pf-ship]', drawer).hidden = true; }
    if (!cart.items.length) {
      items.innerHTML = '<div class="pf-empty"><p>Your cart is empty.</p><p style="margin-top:12px"><a class="pf-btn" href="#pf-buy" data-pf-scroll>Pick your box</a></p></div>';
    } else {
      items.innerHTML = cart.items.map(function (it, i) {
        var pre = it.selling_plan_allocation ? '<div class="pf-line__m">' + esc(G.preorderNote || it.selling_plan_allocation.selling_plan.name) + '</div>' : '';
        var img = it.image || '';
        var off = it.original_line_price > it.final_line_price;
        return '<div class="pf-line" data-line="' + (i + 1) + '">' +
          (img ? '<img src="' + esc(img) + (img.indexOf('?') > -1 ? '&' : '?') + 'width=160" alt="" width="72" height="72" loading="lazy">' : '') +
          '<div class="pf-line__info"><div class="pf-line__t">' + esc(it.product_title) + '</div>' + pre +
          '<div class="pf-line__p"><b>' + money(it.final_line_price) + '</b>' + (off ? '<s>' + money(it.original_line_price) + '</s>' : '') + '</div>' +
          '<div><span class="pf-qty"><button type="button" data-q="-1" aria-label="Decrease quantity">\u2212</button><span aria-live="polite">' + it.quantity + '</span><button type="button" data-q="1" aria-label="Increase quantity">+</button></span>' +
          '<button type="button" class="pf-line__rm" data-rm>Remove</button></div></div></div>';
      }).join('');
      var tpl = $('[data-pf-upsell-tpl]', drawer);
      if (tpl) {
        var holder = document.createElement('div'); holder.appendChild(tpl.content.cloneNode(true));
        var up = holder.firstElementChild;
        var inCart = cart.items.some(function (it) { return String(it.variant_id) === up.getAttribute('data-variant'); });
        if (!inCart) items.appendChild(up);
      }
    }
    $('[data-pf-total]', drawer).textContent = money(now);
    $('[data-pf-was]', drawer).textContent = was > now ? money(was) : '';
    $('[data-pf-tot-note]', drawer).textContent = (codeOn ? Math.round(pct * 100) + '% first-order discount applied. ' : (pct ? Math.round(pct * 100) + '% off your first order is applied at checkout. ' : '')) + 'Taxes and shipping calculated at checkout.';
  }
  function refreshCart() { return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) { renderCart(c); return c; }); }
  if (drawer) {
    drawer.addEventListener('click', function (e) {
      var line = e.target.closest('[data-line]');
      if (line) {
        var q = e.target.closest('[data-q]'), rm = e.target.closest('[data-rm]');
        if (q || rm) {
          var n = +line.getAttribute('data-line');
          var cur = +$('.pf-qty span', line).textContent;
          var qty = rm ? 0 : Math.max(0, cur + +q.getAttribute('data-q'));
          fetch('/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: n, quantity: qty }) })
            .then(function (r) { return r.json(); }).then(renderCart);
        }
      }
      var add = e.target.closest('[data-pf-upsell-add]');
      if (add) {
        var box = add.closest('.pf-upsell'); add.disabled = true; add.textContent = 'Adding…';
        var item = { id: +box.getAttribute('data-variant'), quantity: 1 };
        if (box.getAttribute('data-plan')) item.selling_plan = +box.getAttribute('data-plan');
        addItems([item]).then(refreshCart).catch(function () { add.disabled = false; add.textContent = 'Add'; });
      }
      if (e.target.closest('.pf-empty [data-pf-scroll]')) closeDrawer();
    });
  }
  function addItems(items) {
    return fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart'); return j; }); });
  }

  /* ---------- Quick add (flavor cards) + header cart icon opens the drawer ---------- */
  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-pf-quick]');
    if (q) {
      var item = { id: +q.getAttribute('data-variant'), quantity: 1 };
      if (q.getAttribute('data-plan')) item.selling_plan = +q.getAttribute('data-plan');
      var t = q.textContent; q.disabled = true; q.textContent = 'Adding\u2026';
      addItems([item]).then(applyCode).then(refreshCart).then(function () { q.disabled = false; q.textContent = t; openDrawer(); })
        .catch(function (x) { q.disabled = false; q.textContent = x.message || 'Try again'; setTimeout(function () { q.textContent = t; }, 2500); });
      return;
    }
    var c = drawer && e.target.closest('.posana-nav__cart');
    if (c) { e.preventDefault(); refreshCart().then(openDrawer); }
  });

  /* ---------- Buy box ---------- */
  $$('[data-pf-buybox]').forEach(function (root) {
    var D; try { D = JSON.parse($('[data-pf-bb-data]', root).textContent); } catch (e) { return; }
    var opts = D.options.filter(function (o) { return o.available; });
    if (!opts.length) return;
    var flavors = opts.filter(function (o) { return o.group === 'flavor'; });
    var variety = opts.filter(function (o) { return o.group === 'variety'; });
    var state = { card: flavors.length ? flavors[0].id : 'variety', opt: flavors.length ? flavors[0] : variety[0], plan: 'bundle', pref: 'sub' };
    var pctB = (+D.discountPercent || 0) / 100, thr = +D.freeShipping || 0, bq = +D.bundleQty || 2;

    var cards = $$('[data-pf-flavs] [data-card]', root);
    var sizes = $('[data-pf-sizes]', root);
    var plans = $$('[data-plan]', root);
    var atc = $('[data-pf-atc]', root), err = $('[data-pf-err]', root);

    function optsForCard(c) { return c === 'variety' ? variety : opts.filter(function (o) { return o.id === c; }); }
    function check(svg) { return '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="11" fill="#C92E23"/><path d="M7 12.5l3.2 3.2L17 9" stroke="#fff" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>'; }

    function renderSizes() {
      var list = optsForCard(state.card);
      sizes.innerHTML = list.map(function (o) {
        return '<button type="button" role="radio" aria-checked="' + (o.id === state.opt.id) + '" data-opt="' + o.id + '">' + esc(o.size || (o.bars + ' bars')) +
          (o.sizeTag ? '<span class="pf-pills__tag">' + esc(o.sizeTag) + '</span>' : '') + '</button>';
      }).join('');
    }
    function price() {
      var o = state.opt, p = o.price;
      var off = function (c) { return c - Math.floor(c * pctB); }; // Shopify rounds the discount down per line
      var b = { qty: bq, full: p * bq }; b.now = off(b.full); b.per = b.now / (o.bars * bq);
      var s = { qty: 1, full: p }; s.now = off(p); s.per = s.now / o.bars;
      return { b: b, s: s };
    }
    function li(t) { return '<li>' + check() + '<span>' + t + '</span></li>'; }
    function render() {
      var o = state.opt, pr = price();
      var subCard = $('[data-plan="sub"]', root);
      if (subCard) subCard.hidden = !o.subPlan;
      state.plan = (state.pref === 'sub' && !o.subPlan) ? 'bundle' : state.pref;
      if (o.subPlan && subCard) {
        $('[data-pf-sub-desc]', root).textContent = '1 box \u00b7 ' + o.bars + ' bars';
        $('[data-pf-sub-price]', root).textContent = money(o.subPrice);
        $('[data-pf-sub-was]', root).textContent = o.subPrice < o.price ? money(o.price) : '';
        $('[data-pf-sub-per]', root).textContent = money(o.subPrice / o.bars) + ' / bar';
        var sp = (D.subPerks || []).slice(); if (thr && o.subPrice >= thr) sp.unshift('Free shipping'); if (D.returnsNote) sp.push(esc(D.returnsNote));
        $('[data-pf-sub-perks]', root).innerHTML = sp.filter(Boolean).map(li).join('');
      }
      cards.forEach(function (c) { c.setAttribute('aria-checked', c.getAttribute('data-card') === state.card ? 'true' : 'false'); });
      $('[data-pf-flav-name]', root).textContent = state.card === 'variety' ? D.varietyName : o.name;
      renderSizes();
      var freeB = thr && pr.b.now >= thr, freeS = thr && pr.s.now >= thr;
      $('[data-pf-bundle-banner]', root).textContent = (pctB ? 'Best value: ' + Math.round(pctB * 100) + '% off' : 'Best value') + (freeB ? ' + free shipping' : '');
      $('[data-pf-bundle-desc]', root).textContent = bq + ' boxes · ' + (o.bars * bq) + ' bars';
      $('[data-pf-bundle-price]', root).textContent = money(pr.b.now);
      $('[data-pf-bundle-was]', root).textContent = pctB ? money(pr.b.full) : '';
      $('[data-pf-bundle-per]', root).textContent = money(pr.b.per) + ' / bar';
      var perks = [];
      if (pctB) perks.push(Math.round(pctB * 100) + '% off your first order');
      perks.push(freeB ? 'Free shipping' : (thr ? money(thr - pr.b.now) + ' away from free shipping' : ''));
      perks.push(o.preorder ? esc(D.preorderNote) : esc(D.nowNote));
      if (D.returnsNote) perks.push(esc(D.returnsNote));
      $('[data-pf-bundle-perks]', root).innerHTML = perks.filter(Boolean).map(li).join('');
      $('[data-pf-single-desc]', root).textContent = '1 box · ' + o.bars + ' bars' + (freeS ? ' · free shipping' : '');
      $('[data-pf-single-price]', root).textContent = money(pr.s.now);
      $('[data-pf-single-was]', root).textContent = pctB ? money(pr.s.full) : '';
      $('[data-pf-single-per]', root).textContent = money(pr.s.per) + ' / bar';
      plans.forEach(function (p) { p.setAttribute('aria-checked', p.getAttribute('data-plan') === state.plan ? 'true' : 'false'); });
      var tot = state.plan === 'sub' ? o.subPrice : state.plan === 'bundle' ? pr.b.now : pr.s.now;
      atc.textContent = (state.plan === 'sub' ? 'Subscribe' : o.preorder ? 'Pre-order' : 'Add to cart') + ' · ' + money(tot);
      $('[data-pf-fine]', root).textContent = [state.plan === 'sub' ? D.subFine : D.offerNote, o.preorder ? D.preorderNote + '.' : ''].filter(Boolean).join(' ');
      $('[data-pf-ingr]', root).innerHTML = (o.ingredients || '<p>Ingredients are printed on every wrapper. Questions? Email team@eatposana.com.</p>') + (o.allergens ? '<p><b>Allergens:</b> ' + esc(o.allergens) + '</p>' : '');
      $('[data-pf-nutr]', root).innerHTML = o.nutrition || '<p>See the nutrition label on the wrapper.</p>';
      var lb = $('[data-pf-label-open]', root); if (lb) lb.hidden = !o.hasLabel;
      gallery();
    }

    /* gallery: shared slides + the selected option's photos */
    var main = $('[data-pf-gal-main]', root), thumbs = $('[data-pf-gal-thumbs]', root);
    function gallery() {
      var slides = $$('.pf-gal__slide', main);
      var shown = slides.filter(function (s) { var k = s.getAttribute('data-opt'); var on = k === '*' || k === state.opt.id; s.hidden = !on; return on; });
      // keep the box slide first, then this option's photos, then the extras
      thumbs.innerHTML = shown.map(function (s, i) {
        var im = $('img', s); var src = im ? (im.currentSrc || im.src) : '';
        return '<button type="button" aria-label="Show photo ' + (i + 1) + '" aria-current="' + (i === 0) + '" data-i="' + i + '"><img src="' + esc(src.replace(/width=\d+/, 'width=160')) + '" alt="" loading="lazy" width="58" height="58"></button>';
      }).join('');
      main.scrollTo({ left: 0 });
      main._shown = shown;
    }
    thumbs.addEventListener('click', function (e) {
      var b = e.target.closest('[data-i]'); if (!b) return;
      var s = main._shown[+b.getAttribute('data-i')]; if (!s) return;
      main.scrollTo({ left: s.offsetLeft - main.offsetLeft, behavior: 'smooth' });
    });
    var st; main.addEventListener('scroll', function () {
      clearTimeout(st); st = setTimeout(function () {
        var i = Math.round(main.scrollLeft / main.clientWidth);
        $$('[data-i]', thumbs).forEach(function (t) { t.setAttribute('aria-current', +t.getAttribute('data-i') === i ? 'true' : 'false'); });
      }, 80);
    }, { passive: true });

    /* nutrition label modal */
    var modal = $('[data-pf-label-modal]', root);
    var lbo = $('[data-pf-label-open]', root);
    if (modal && lbo) {
      lbo.addEventListener('click', function () {
        $$('[data-label-for]', modal).forEach(function (d) { d.hidden = d.getAttribute('data-label-for') !== state.opt.id; });
        $('[data-pf-label-name]', modal).textContent = state.opt.name;
        if (modal.showModal) modal.showModal(); else modal.setAttribute('open', '');
      });
      $('[data-pf-label-close]', modal).addEventListener('click', function () { modal.close(); });
      modal.addEventListener('click', function (e) { if (e.target === modal) modal.close(); });
    }

    /* choices */
    root.addEventListener('click', function (e) {
      var c = e.target.closest('[data-pf-flavs] [data-card]');
      if (c) { state.card = c.getAttribute('data-card'); state.opt = optsForCard(state.card)[0] || state.opt; render(); return; }
      var z = e.target.closest('[data-pf-sizes] [data-opt]');
      if (z) { var id = z.getAttribute('data-opt'); state.opt = opts.filter(function (o) { return o.id === id; })[0] || state.opt; render(); return; }
      var p = e.target.closest('[data-plan]');
      if (p) { state.pref = p.getAttribute('data-plan'); render(); }
    });
    /* arrow keys inside radio groups */
    root.addEventListener('keydown', function (e) {
      if (['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp'].indexOf(e.key) < 0) return;
      var g = e.target.closest('[role=radiogroup]'); if (!g) return;
      var rs = $$('[role=radio]', g), i = rs.indexOf(e.target); if (i < 0) return;
      e.preventDefault();
      var n = rs[(i + (e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : rs.length - 1)) % rs.length];
      n.click(); var again = $$('[role=radio]', g)[rs.indexOf(n)]; if (again) again.focus();
    });
    // disable cards with no buyable product
    cards.forEach(function (c) { if (!optsForCard(c.getAttribute('data-card')).length) { c.disabled = true; c.setAttribute('aria-disabled', 'true'); } });

    atc.addEventListener('click', function () {
      var o = state.opt, qty = state.plan === 'bundle' ? bq : 1;
      var item = { id: o.variantId, quantity: qty };
      if (state.plan === 'sub' && o.subPlan) item.selling_plan = o.subPlan;
      else if (o.sellingPlan) item.selling_plan = o.sellingPlan;
      err.textContent = ''; atc.disabled = true; var t = atc.textContent; atc.textContent = 'Adding…';
      addItems([item]).then(applyCode).then(refreshCart).then(function () { atc.disabled = false; atc.textContent = t; openDrawer(); })
        .catch(function (x) { atc.disabled = false; atc.textContent = t; err.textContent = x.message || 'Something went wrong. Please try again.'; });
    });

    render();
  });
})();
